import { render, staticRenderFns } from "./CriterioGroup.vue?vue&type=template&id=7331d99d&"
import script from "./CriterioGroup.vue?vue&type=script&lang=js&"
export * from "./CriterioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports